import {createContext} from 'react'

const CredentialsContext = createContext()

export default CredentialsContext